import { PropsWithChildren } from 'react'
import { LogoFull } from '../kit/icons/logos'

const FlowPageLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Flex
      $flexDirection='column'
      $alignItems='center'
      $justifyContent='center'
      $maxWidth={512}
      $flex={1}
      $gap='lg'
      $m='auto'
      $overflowY='auto'
    >
      <LogoFull height={64} />
      {children}
    </Flex>
  )
}

export default FlowPageLayout
